import React from 'react';
import {Button, ModalCard} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {handleSubscribe} from "../../utils/subscription";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_PRIMARY_BUTTON_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS,
    MODAL_SUBHEADER_CLASS
} from "../modalStyles";

export const SubscribeToTournamentModal = ({nav}) => {
    const routeNavigator = useRouteNavigator();

    // onSubscribeClick вызывает хук подписки и в любом случае закрывает модальное окно
    const onSubscribeClick = () => {
        handleSubscribe().then(() => {
            routeNavigator.hideModal();
        }).catch(() => {
            // Можно показать snackbar с ошибкой, если нужно
            routeNavigator.hideModal();
        });
    };

    return (
        <ModalCard
            nav={nav}
            onClose={() => routeNavigator.hideModal()}
            className={MODAL_CARD_CLASS}
            // icon={<Icon28MailOutline/>}
            header={<span className={MODAL_HEADER_CLASS}>Good luck in the tournament!</span>}
            subheader={
                <span className={MODAL_SUBHEADER_CLASS}>
                    Subscribe to notifications to track your progress and never miss important updates.
                </span>
            }
            actions={
                <div className={"flex flex-col w-full gap-2"}>
                    <Button size="l"
                            mode="primary"
                            className={`rounded border-solid border-2 border-yellow-400/20 ${MODAL_PRIMARY_BUTTON_CLASS}`}
                            onClick={onSubscribeClick}>
                        Subscribe
                    </Button>
                    <Button
                        size="l"
                        mode="secondary"
                        className={MODAL_SECONDARY_BUTTON_CLASS}
                        onClick={() => routeNavigator.hideModal()}
                    >
                        Later
                    </Button>
                </div>
            }
        />
    );
};
